import { render, staticRenderFns } from "./administrator.form.vue?vue&type=template&id=5963f10b&"
import script from "./administrator.form.vue?vue&type=script&lang=js&"
export * from "./administrator.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports